module.exports = __webpack_public_path__ + "static/gothic-a1-v8-latin-300-a439f9a7fd528c1ba71470a111726546.woff";